import React from 'react';
import { STATIC_UPPSALA_SVG_URL } from '../../lib/constants';
const Spinner = (props) => {
    const getSize = () => {
        switch (props.size) {
            case 'sm':
                return 24;
            case 'md':
                return 50;
            default:
                return 50;
        }
    };
    const size = getSize();
    return (React.createElement("div", { className: `flex items-center gap-5 ${props.className ?? ''}`, style: props.style },
        props.title && React.createElement("span", null, props.title),
        React.createElement("img", { src: STATIC_UPPSALA_SVG_URL + `spinner${props.onSurface ? '-white' : ''}.svg`, alt: "spinner-icon", height: size, width: size })));
};
export default Spinner;
